import { FormControl } from '@angular/forms';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subscription } from 'rxjs';

import { ApiVerificationService } from 'src/app/services/api/api-verification.service';
import { IPagination } from 'src/app/models/generic';

@Component({
  selector: 'app-pagination-footer',
  templateUrl: './pagination-footer.component.html',
  styleUrls: ['./pagination-footer.component.scss']
})
export class PaginationFooterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() count!: number;
  @Input() showItemsPerPage: boolean = true;
  @Input() perPage: number = 10;
  @Input() appearance: 'legacy' | 'modern' = 'legacy';

  @Output() paginationTrigger = new EventEmitter<IPagination>();

  pageControl = new FormControl<number>(10);

  readonly options = [10, 25, 50, 100];

  page = 1;

  totalPages = 1;

  readonly FIRST_PAGE = 1;

  lastPage = this.FIRST_PAGE;

  disabled: boolean = false;

  subscription!: Subscription;

  public pageController = {
    nextPage: () => {
      this.page++;

      this.paginationTrigger.emit({
        Skip: (this.page - 1) * this.perPage,
        Take: this.perPage
      });
    },
    sendToLastPage: () => {
      this.page = this.lastPage;

      this.paginationTrigger.emit({
        Skip: (this.page - 1) * this.perPage,
        Take: this.perPage
      });
    },
    previousPage: () => {
      this.page--;

      this.paginationTrigger.emit({
        Skip: (this.page - 1) * this.perPage,
        Take: this.perPage
      });
    },
    sendToFirstPage: () => {
      this.page = this.FIRST_PAGE;

      this.paginationTrigger.emit({
        Skip: 0,
        Take: this.perPage
      });
    },
    handlePerPage: (perPage: number) => {
      this.perPage = perPage;
      this.totalPages = Math.ceil(this.count / this.perPage);
      this.page = this.FIRST_PAGE;
      this.lastPage = this.totalPages;

      this.paginationTrigger.emit({
        Skip: 0,
        Take: this.perPage
      });
    },
    changePage: (action: number, full?: boolean) => {
      if (action === 1) {
        if (full) {
          this.pageController.sendToFirstPage();
        } else if (this.page > 1) {
          this.pageController.previousPage();
        }
      } else {
        if (full) {
          this.pageController.sendToLastPage();
        } else if (this.page < this.totalPages) {
          this.pageController.nextPage();
        }
      }
    }
  };

  constructor(private _verificationService: ApiVerificationService) {}

  ngOnChanges(changes: any) {
    this.page = this.FIRST_PAGE;
    this.totalPages = Math.ceil(this.count / this.perPage);
    this.lastPage = this.totalPages;
  }

  ngOnInit(): void {
    this.subscribePageControl();
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  subscribePageControl(): void {
    this.subscription = this.pageControl.valueChanges.subscribe({
      next: (page) => {
        if (page) {
          this.pageController.handlePerPage(page);
        }
      }
    });
  }

  disableButton(action: number) {
    return (
      (action === 1 && this.page === 1) ||
      (action === 2 && this.page === this.totalPages)
    );
  }
}
